
class UserController {

}

export { UserController }